import React, { Fragment } from 'react'
import { Redirect } from 'react-router-dom'

type Props = {
    children: any,
    feature: string,
    features?: Array<string>,
    availableFeatures: Array<string>,
    shouldRedirect?: boolean,
    ignore?: boolean
}

const FeatureToggleComponent = (props: Props) => {
    const {
        availableFeatures,
        children,
        feature,
        features,
        shouldRedirect,
        ignore
    } = props || {}

    const shouldDisplay =
        ignore ||
        (feature &&
            !!availableFeatures &&
            availableFeatures.includes(feature)) ||
        (features &&
            !!availableFeatures &&
            availableFeatures.filter(availableFeature =>
                features.includes(availableFeature)
            ).length > 0)

    if (availableFeatures.length > 0 && !shouldDisplay && shouldRedirect) {
        return <Redirect to="/" />
    }
    if (shouldDisplay) {
        return <Fragment>{children}</Fragment>
    }
    return <Fragment></Fragment>
}

export { FeatureToggleComponent }
